<template>
  <div class="xiaomi-page">
    <transition mode="out-in">
      <v-container  v-if="SponsorXiaomi && SponsorXiaomi._slug == $language.current && !infoOpen" key="loaded-noinfo">
        <seo-v-img eager :src="bgImage" class="bg-image" width="100vw" height="100vh" position="0 0" cover />
        <v-row align="center" justify="center" no-gutters class="mt-8 mt-md-0">
          <v-col class="shrink">
            <a href="https://www.mi.com" rel="noopener" target="_blank">
              <seo-v-img :src="logo" :width="$vuetify.breakpoint.mdAndUp ? '200px' : '100px'" />
            </a>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" no-gutters>
          <v-col class="shrink">
            <transition appear name="from-below">
              <v-responsive :aspect-ratio="16/9" width="100vw" class="mb-4" style="--appear-delay: 100ms;">
                <vue-plyr :emit="['playing','pause', 'ended']" @playing="$root.soundManager.mute('content')" @pause="$root.soundManager.unmute('content')" @ended="$root.soundManager.unmute('content')">
                  <div data-plyr-provider="youtube" :data-plyr-embed-id="getVideoId(SponsorXiaomi.youtubeVideoURL).id"></div>
                </vue-plyr>
              </v-responsive>
            </transition>
            <transition appear name="from-below"><p style="--appear-delay: 200ms;" class="video-title ml-md-n8 px-8 px-md-0">{{SponsorXiaomi.title}}</p></transition>
            <transition appear name="from-below"><MarkdownBlock tag="div" style="--appear-delay: 300ms;" class="video-subtitle ml-md-n4 px-8 px-md-0 mb-16 mb-md-0" :text="SponsorXiaomi.paragraph" /></transition>
            <transition appear name="from-below"><v-btn style="--appear-delay: 400ms;" class="ml-md-n8 more-info-btn" text dark @click="infoOpen = true">{{SponsorXiaomi.infoCTALabel}}</v-btn></transition>
          </v-col>
        </v-row>
      </v-container>
      <v-container  v-else-if="SponsorXiaomi && SponsorXiaomi._slug == $language.current && infoOpen"  key="loaded-info">
        <v-row align="center" justify="center"  no-gutters class="mb-8 mt-8 mt-md-0">
          <v-col class="shrink">
            <a href="https://www.mi.com" rel="noopener" target="_blank">
              <seo-v-img :src="logo" :width="$vuetify.breakpoint.mdAndUp ? '200px' : '100px'" />
            </a>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" no-gutters class="mb-16">
          <v-col class="shrink">
            <v-btn aria-label="Close" data-cursor-target="center center" icon exact @click="infoOpen = false" class="close-btn"><CloseIcon class="close-icon"/></v-btn>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" no-gutters>
          <v-col class="shrink">
            <transition appear name="from-below">
              <seo-v-img style="--appear-delay: 100ms;" :src="`/media/${SponsorXiaomi.infoHeroImage.id}`" :lazy-src="JSON.parse(SponsorXiaomi.infoHeroImage.metaData)['image-lazy-src']" width="100%" class="mb-8" />
            </transition>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" no-gutters>
          <v-col class="text-center">
            <div class="mb-16">
              <CharSplitText tag="h1" class="d-block" :text="SponsorXiaomi.infoTitle" />
              <CharSplitText tag="h2" class="d-block" v-if="SponsorXiaomi.infoSubtitle && SponsorXiaomi.infoSubtitle.length > 0" :text="SponsorXiaomi.infoSubtitle" />
            </div>
            <transition appear name="from-below"><MarkdownBlock style="--appear-delay: 400ms;" tag="div" :text="SponsorXiaomi.infoText" class="info-paragraph mb-16" /></transition>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" no-gutters>
          <v-col class="shrink socials">
            <transition appear name="from-below"><SocialRepeater style="--appear-delay: 1000ms;" class="grow ml-n2 mt-1" :data="SponsorXiaomi.infoSocials" /></transition>
          </v-col>
        </v-row>
      </v-container>
      <v-row v-else class="fill-height" align="center" justify="center" key="loading">
        <v-col class="shrink"><LoadingSpinner /></v-col>
      </v-row>
    </transition>
  </div>
</template>

<script>
import logo from '@/assets/img/xiaomi-logo-min.png'
import GetSponsorXiaomi from '@/graphql/GetSponsorXiaomi.gql'
import LoadingSpinner from '@/atoms/LoadingSpinner'
import getVideoId from 'get-video-id'
import { MarkdownBlock } from '@monogrid/vue-lib'
import SocialRepeater from '@/molecules/SocialRepeater'
import CharSplitText from '@/atoms/CharSplitText'
import bgImage from '@/assets/img/xiaomi-bg-min.png'
import CloseIcon from '@/assets/img/close.svg'

export default {
  name: 'XiaomiPage',
  components: {
    LoadingSpinner,
    MarkdownBlock,
    SocialRepeater,
    CharSplitText,
    CloseIcon
  },
  apollo: {
    SponsorXiaomi: {
      query () {
        return GetSponsorXiaomi
      },
      variables () {
        return {
          slug: this.$language.current,
          status: 'PUBLISHED'
        }
      },
      result () {
        this.$root.$emit('scroll-to-saved-position')
      }
    }
  },
  data () {
    return {
      logo,
      bgImage,
      infoOpen: false
    }
  },
  methods: {
    getVideoId
  }
}
</script>
<style lang="scss" scoped>

@font-face {
  font-family: 'Camphor Pro';
  src: url('../../assets/fonts/CamphorPro-Heavy.woff2') format('woff2'),
    url('../../assets/fonts/CamphorPro-Heavy.woff') format('woff');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Camphor Pro';
  src: url('../../assets/fonts/CamphorPro-Light.woff2') format('woff2'),
    url('../../assets/fonts/CamphorPro-Light.woff') format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Camphor Pro';
  src: url('../../assets/fonts/CamphorPro-Regular.woff2') format('woff2'),
    url('../../assets/fonts/CamphorPro-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Camphor Pro';
  src: url('../../assets/fonts/CamphorPro-Bold.woff2') format('woff2'),
    url('../../assets/fonts/CamphorPro-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Camphor Pro';
  src: url('../../assets/fonts/CamphorPro-Thin.woff2') format('woff2'),
    url('../../assets/fonts/CamphorPro-Thin.woff') format('woff');
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Camphor Pro';
  src: url('../../assets/fonts/CamphorPro-Medium.woff2') format('woff2'),
    url('../../assets/fonts/CamphorPro-Medium.woff') format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

.info-paragraph {
  font-family: 'Camphor Pro', sans-serif;
  font-weight: 300;
}

.xiaomi-page {
  background: rgb(203, 232, 232);
  background: linear-gradient(90deg, rgba(203, 232, 232, 1) 0%, rgba(219, 232, 232, 1) 12%, rgba(233, 237, 233, 1) 25%, rgba(228, 230, 230, 1) 37%, rgba(239, 234, 231, 1) 50%, rgba(234, 226, 231, 1) 62%, rgba(237, 224, 235, 1) 75%, rgba(249, 238, 248, 1) 87%, rgba(242, 218, 241, 1) 100%);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  // background-image: url('../../assets/img/xiaomi-bg-min.png');
  // background-position: top left;
  // background-repeat: no-repeat;
}

h1 {
  font-family: 'Camphor Pro', sans-serif;
  font-weight: 100;
  color: #262626;
  opacity: 0.6;

  @include breakpoint('md-and-down') {
    font-size: 1.85rem;
  }
}

h2 {
  font-family: 'Camphor Pro', sans-serif;
  color: #ea5b0c;
}

.socials {
  white-space: nowrap;

  ::v-deep svg {
    color: #ea5b0c;
  }
}

.container {
  max-width: 900px;
}

::v-deep .plyr__control--overlaid {
  background: #ea5b0c !important;
}

::v-deep input[type=range] {
  color: #ea5b0c !important;
}

::v-deep .plyr__control:hover {
  background: #ea5b0c !important;
}

.v-btn {
  background-color: #ea5b0c;
  border-radius: 0;
  font-family: 'Camphor Pro', sans-serif;
  font-weight: bold;
  text-transform: lowercase !important;

  @include breakpoint('md-and-down') {
    display: block;
    margin: 0 auto;
  }
}

.video-title {
  // width: 607px;
  // height: 28px;
  font-family: 'Camphor Pro', sans-serif;
  font-size: 1.6875rem;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  // text-align: center;
  color: #262626;

  @include breakpoint('md-and-down') {
    font-size: 1.225rem;
  }
}

.video-subtitle {
  // width: 607px;
  // height: 28px;
  font-family: 'Camphor Pro', sans-serif;
  font-size: 1.125rem;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  text-align: left;
  color: #262626;
  @include breakpoint('md-and-down') {
    font-size: 1rem;
  }
}

.bg-image {
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  // width: 200vh;
  // height: 200vh;
  // top: -20%;
  // left: -20%;
  // width: 130%;
  // height: 130%;
  opacity: 0.2;
}

.close-icon {
  width: 12px;
  height: 12px;
  color: map-get($shades, 'black');
  stroke: currentColor;
}

.close-btn {
  background-color: transparent;
}
</style>
